import Axios from "axios";
import {handleAjaxSuccess, swalConfirm} from "../../../helpers/swalHelper";
import handleAjaxError from "../../../helpers/handleAjaxError";
import {loading, stopLoading} from "../../../helpers/loading";

function initProductionAuditionContractsView() {
	const rescheduleButton = document.querySelector(".reschedule-email-button");
	rescheduleButton.addEventListener("click", handleRescheduleEmail);

	/** Methods */
	function handleRescheduleEmail() {
		swalConfirm({
			title: "Are you sure you want to send contract notification email for this contract?",
		}).then((response) => {
			if (response.isConfirmed) {
				loading();

				Axios.post(rescheduleButton.dataset.route)
					.then(handleAjaxSuccess)
					.catch(handleAjaxError)
					.finally(stopLoading);
			}
		});
	}
}

export {initProductionAuditionContractsView};
